import React, { useState } from "react";
import images from "../../../Utils/importImages";
import TravellerForm from "./TravellerForm";

function TravellersRow({ Data, onClickRemove, onClickSaveEditTravel, key }) {
  let [showDetail, setShowDetail] = useState(false);

  const getMatureStatus = (dob) => {
    if (!dob) return;
    if (dob.includes("DD") || dob.includes("MM") || dob.includes("YYYY"))
      return;

    // Convert DOB to a Date object
    let birthDate = new Date(dob);
    if (isNaN(birthDate)) return; // Invalid date check

    // Calculate age
    let today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    let monthDiff = today.getMonth() - birthDate.getMonth();
    let dayDiff = today.getDate() - birthDate.getDate();

    // Adjust age if birthdate hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    // Determine status based on age
    if (age < 2) return "Infant";
    if (age >= 2 && age < 12) return "Child";
    if (age >= 12 && age < 60) return "Adult";
    return "Senior Citizen";
  };

  let [editTheTraveller, setEditTheTraveller] = useState(false);

  let updateTheData = (data) => {
    onClickSaveEditTravel(data, Data.id);
    setEditTheTraveller(false);
  };

  let getTitle = () => {
    if (Data.gender == "Male") {
      return "Mr";
    } else if (Data.gender == "Female") {
      return "Mrs";
    } else if (Data.gender == "Other") {
      return "Mr";
    }
    return "Mr";
  };

  let getDateFormatted = (date) => {
    if (!date) return ""; // Handle cases where date is undefined or null

    let [year, month, day] = date.split("-"); // Assuming format is "DD-MM-YYYY"

    // Convert month number to month name
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let monthName = monthNames[parseInt(month, 10) - 1]; // Convert month to index

    return `${day} / ${monthName} / ${year}`;
  };

  const isPassportExpired = (ppvalue) => {
    if (!ppvalue) return false; // If null, assume it's not expired (or handle as needed)

    const expiryDate = new Date(ppvalue);
    const today = new Date();

    // Ensure the provided date is valid
    if (isNaN(expiryDate.getTime())) {
      console.warn("Invalid date format:", ppvalue);
      return false;
    }

    return expiryDate < today; // Returns true if expired, false otherwise
  };

  let removeTheElement = (id) => {
    onClickRemove(id , setShowDetail)
  }
  return !editTheTraveller ? (
    <ul className="travellers-list-userdb" key={key}>
      <li>
        <div className="traveller-accordion-header">
          <div className="traveller-left-data">
            <div className="traveller-ico-userdb">
              <img src={images["traveller-user-ico.svg"]} alt="" />
            </div>
            <div
              className="traveller-name-userdb"
              style={{ textTransform: "capitalize" }}
            >
               {Data.title} {Data.first_name} {Data.last_name}
            </div>
            <div className="traveller-type-userdb">
              {getMatureStatus(Data.date_of_birth)}
            </div>
          </div>
          <div className="traveller-right-data">
            {showDetail && (
              <div className="editable-profile-action">
                <ul className="userdb-cta-buttons">
                  <li
                    className="userdb-remove-btn"
                    onClick={() => removeTheElement(Data.id)}
                  >
                    Remove
                  </li>
                  <li
                    className="userdb-save-btn"
                    onClick={() => setEditTheTraveller(true)}
                  >
                    Edit
                  </li>
                </ul>
              </div>
            )}
            <div
              className="details-collapsed"
              onClick={() => setShowDetail(!showDetail)}
            >
              {showDetail ? "Hide" : "Show"} Details{" "}
              <img
                src={
                  images[
                    showDetail ? "collapsed-arrow.svg" : "expanded-arrow.svg"
                  ]
                }
              />
            </div>
          </div>
        </div>
        {showDetail && (
          <div className="travellers-list-expanded-details">
            <div className="top-expanded-traveller">
              <div className="internal-tab-head">
                <h3>General Details</h3>
              </div>
              <ul className="myprofile-general-details">
                <li>
                  <label for="">Name</label>
                  <div
                    className="myprofile-general-value"
                    style={{ textTransform: "capitalize" }}
                  >
                    {Data.title} {Data.first_name} {Data.last_name}
                  </div>
                </li>
                <li>
                  <label for="">Birthday</label>
                  <div className="myprofile-general-value">
                    {" "}
                    {Data.date_of_birth == null ? (
                      <span>Not Provided</span>
                    ) : (
                      getDateFormatted(Data.date_of_birth)
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Gender</label>
                  <div className="myprofile-general-value">
                    {" "}
                    {Data.gender == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.gender
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Email</label>
                  <div className="myprofile-general-value">
                    {Data.email == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.email
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Mobile No.</label>
                  <div className="myprofile-general-value">
                    {Data.phone_number == null ? (
                      <span>Not Provided</span>
                    ) : (
                      `${Data?.dial_code?.phone} - ${Data.phone_number}`
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Relationship</label>
                  <div className="myprofile-general-value">
                    {Data.relationship == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.relationship
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Address</label>
                  <div className="myprofile-general-value">
                    {Data.address == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.address
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Pin Code</label>
                  <div className="myprofile-general-value">
                    {" "}
                    {Data.pincode == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.pincodeme
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Country</label>
                  <div className="myprofile-general-value country">
                    {" "}
                    {Data.country_id == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.country.name
                    )}
                  </div>
                </li>
                <li>
                  <label for="">State</label>
                  <div className="myprofile-general-value">
                    {" "}
                    {Data.state_id == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.state.name
                    )}
                  </div>
                </li>
              </ul>
            </div>
            <div className="top-expanded-traveller">
              <div className="internal-tab-head">
                <h3>PASSPORT DETAILS</h3>
              </div>
              <ul className="myprofile-general-details">
                <li>
                  <label for="">Passport No.</label>
                  <div className="myprofile-general-value country">
                    {Data.passport_number == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.passport_number
                    )}
                  </div>
                </li>
                <li
                  className={
                    isPassportExpired(Data.passport_expiry_date)
                      ? "list-maintainer"
                      : ""
                  }
                >
                  <label for="">Passport Expiry</label>
                  <div className="myprofile-general-value">
                    {Data.passport_expiry_date == null ? (
                      <span>Not Provided</span>
                    ) : isPassportExpired(Data.passport_expiry_date) ? (
                      <div className="status-wrapper">
                        {getDateFormatted(Data.passport_expiry_date)}
                        <div className="expired proxima_semibold color_crimson">
                          Expired
                        </div>
                      </div>
                    ) : (
                      getDateFormatted(Data.passport_expiry_date)
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Passport Issue Date</label>
                  <div className="myprofile-general-value">
                    {Data.passport_issue_date == null ? (
                      <span>Not Provided</span>
                    ) : (
                      getDateFormatted(Data.passport_issue_date)
                    )}
                  </div>
                </li>
                <li>
                  <label for="">Issuing Country</label>
                  <div className="myprofile-general-value country">
                    {Data.passport_issuing_country_id == null ? (
                      <span>Not Provided</span>
                    ) : (
                      Data.passport_issuing_country.name
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        )}
      </li>
    </ul>
  ) : (
    <TravellerForm
      Data={Data}
      onClickCancel={() => setEditTheTraveller(false)}
      onClickSave={updateTheData}
    />
  );
}

export default TravellersRow;
